export enum MilestoneScheduleStatus {
    Complete = "Complete",
    PastDue = "Past Due",
    Upcoming = "Upcoming",
    Scheduled = "Scheduled",
    NotScheduled = "Not Scheduled"
}